module.exports = __webpack_public_path__ + "media/pricing/Coronavirus_Employee_Waiver-4bc2c92a.pdf";